import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'sm-copy-link-comp',
  templateUrl: './copy-link-comp.component.html',
  styleUrls: ['./copy-link-comp.component.scss']
})
export class CopyLinkCompComponent implements OnInit {
  msg:any
  copied:boolean = false
  constructor(@Inject(MAT_DIALOG_DATA) public parentData: any,) { }
  inviteType: 'whatsapp' | 'email' = 'whatsapp';

  ngOnInit(): void {
    console.log(this.parentData.data);
    this.msg = this.parentData.data
  }

  copyInputMessage(inputElement:any){
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
    this.copied=true
  }
}
